import { Typography, message, Input, Row, Col, Card } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import ClientesIndex from "./ClientesIndex"; // Assume you have a component to display clients
import axios from "axios";
import { useAuth } from "../../layout/auth";

export default function Clients() {
  const [clientes, setClientes] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredClientes, setFilteredClientes] = useState([]);
  const [loading, setLoading] = useState(false);

  const auth = useAuth();

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/clientes`)
      .then((res) => {
        setClientes(res.data);
        setFilteredClientes(res.data); // Initialize filtered clients
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.message);
      });
  }, []);

  useEffect(() => {
    if (search) {
      const filtered = clientes.filter((cliente) => {
        return (
          cliente?.NombreCliente?.toLowerCase().includes(search.toLowerCase()) ||
          cliente?.Email?.toLowerCase().includes(search.toLowerCase()) ||
          cliente?.Telefono?.toLowerCase().includes(search.toLowerCase())
        );
      });
      setFilteredClientes(filtered);
    } else {
      setFilteredClientes(clientes);
    }
  }, [search, clientes]);

  return (
    <div>
      <Card style={{ borderRadius: "12px", boxShadow: "0 4px 12px rgba(0,0,0,0.08)", marginBottom: "20px" }} bodyStyle={{ padding: "24px" }}>
        <Typography.Title level={3} style={{ margin: 0, color: "#1890ff" }}>
          <UserOutlined style={{ marginRight: "12px" }} />
          Clientes
        </Typography.Title>
        <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Input.Search placeholder="Buscar clientes" onSearch={(value) => setSearch(value)} enterButton="Buscar" loading={loading} />
          </Col>
        </Row>
      </Card>
      <Card style={{ borderRadius: "12px", boxShadow: "0 4px 12px rgba(0,0,0,0.08)" }} bodyStyle={{ padding: "24px" }}>
        <ClientesIndex clientes={filteredClientes} loading={loading} />
      </Card>
    </div>
  );
}
